import type {
  AuditLogsListRequestQuery,
  AuditLogsListResponse
} from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

export const GET_AUDIT_LOGS = `/api/list/audit-logs`

const useAuditTrail = ({
  from,
  to,
  agentId,
  pagination,
  changeType
}: AuditLogsListRequestQuery) => {
  const queryParams = getQueryParams({
    from,
    to,
    agentId,
    pagination,
    changeType
  })
  const { isLoading, data } = useQuery<{
    data: AuditLogsListResponse[]
    pagination: { totalItems: number }
  }>([`audit-logs`, queryParams], () =>
    getJSON({
      url: queryParams ? `${GET_AUDIT_LOGS}?${queryParams}` : GET_AUDIT_LOGS
    })
  )

  return {
    isLoading,
    auditLogs: data?.data || [],
    pagination: data?.pagination
  }
}

export default useAuditTrail
